import { create } from 'zustand';
import Consolidated from '~/@core/domain/model/rfidReports/Consolidated';
import TablePagination from '~/@core/domain/ui/TablePagination';

interface ConsolidatedState {
  consolidateds: Consolidated[];
  consolidatedPagination: TablePagination;
  isLoadingConsolidated: boolean;
  handleConsolidatedPagination: (newPagination: TablePagination) => void;
  addConsolidateds: (consolidatedsValues: Consolidated[]) => void;
  setIsLoadingConsolidated: () => void;
}

const useConsolidatedStore = create<ConsolidatedState>()(set => ({
  consolidateds: [],
  consolidatedPagination: {
    pageSize: 10,
    current: 1,
    total: 1
  },
  isLoadingConsolidated: false,
  handleConsolidatedPagination: newPagination =>
    set({ consolidatedPagination: newPagination }),
  addConsolidateds: consolidatedsValues =>
    set({ consolidateds: consolidatedsValues }),
  setIsLoadingConsolidated: () => {
    set(state => ({ isLoadingConsolidated: !state.isLoadingConsolidated }));
  }
}));

export default useConsolidatedStore;
